import { UserContract } from "../../types/responseTypes";

async function getUserContract(contractId: string, signeeId: string): Promise<UserContract | null> {
  try {
    const url = `https://ruuf-backend.online/contract/get-specific-contract/${contractId}/${signeeId}`;
    const timeout = new Promise<Response>((_, reject) =>
      setTimeout(() => reject(new Error("Request timed out")), 10000),
    );

    const response = await Promise.race([
      fetch(url, {
        method: "GET",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
          "cookie": document.cookie,
        },
      }),
      timeout,
    ]);

    if (!(response instanceof Response)) {
      throw response;
    }

    if (response.status === 200) {
      console.log("User Contract fetched successfully");
      const userContract: UserContract = await response.json();
      return userContract;
    } else if (response.status === 400) {
      console.error("Error fetching user contracts");
      return null;
    } else {
      throw new Error("Could not fetch user contracts");
    }
  } catch (error) {
    console.error("Error fetching user contracts:", error);
    return null;
  }
}

export default getUserContract;
